<template>
  <div>
    <v-menu
      offset-x
      absolute
      v-model="showMenu"
      style="max-width: 600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark :left="$vuetify.breakpoint.smAndUp">mdi-store-marker</v-icon>
          <div v-if="$vuetify.breakpoint.smAndUp">
            {{ selectedLocal && selectedLocal.abreviatura ? selectedLocal.abreviatura : '---'}}
          </div>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in all"
          :key="index"
          @click="onSelect(item)"
        >
          <v-list-item-icon>
            <v-icon>{{ selectedLocal.id === item.id ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline'}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.abreviatura }}. {{ item.nombre }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'SucursalesSelectComponent',
  data () {
    return {
      showMenu: false,
    }
  },
  computed: {
    ...mapGetters('Sucursales', ['all', 'selected']),
    selectedLocal: {
      get () {
        return this.selected
      },
      set (value) {
        this.setSelected(value)
      }
    },
  },
  watch: {
    async selectedLocal (newValue) {
      const aux = newValue && newValue.id > 0 ? newValue.id : null
      await window.sessionStorage.setItem('sucid', JSON.stringify(aux))
      this.$root.$emit('update:sucursal_id', aux)
    }
  },
  methods: {
    ...mapActions('Sucursales', ['onFetch', 'onClearSelected']),
    ...mapMutations('Sucursales', ['setSelected', 'setAll']),
    onSelect (item) {
      if (item && item.id) {
        this.selectedLocal = item
      }
    }
  }
}
</script>
